<span class="sc-button-wrapper">
    <ng-content></ng-content>
</span>
